var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScriptsSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1429 6V19.7143C17.1429 20.6236 16.7816 21.4957 16.1387 22.1387C15.4957 22.7816 14.6236 23.1429 13.7143 23.1429H0.857143C1.76646 23.1429 2.63853 22.7816 3.28151 22.1387C3.92449 21.4957 4.28571 20.6236 4.28571 19.7143V4.28572C4.28571 3.3764 4.64694 2.50433 5.28992 1.86135C5.9329 1.21837 6.80497 0.857147 7.71429 0.857147H20.1429",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2857 6.85715H12.8571M8.57143 12H12.8571M8.57143 17.1429H12.8571M20.1429 0.857147C20.9385 0.857147 21.7016 1.17322 22.2642 1.73583C22.8268 2.29844 23.1429 3.0615 23.1429 3.85715V5.14286C23.1429 5.37019 23.0526 5.58821 22.8918 5.74895C22.7311 5.9097 22.513 6 22.2857 6H17.1429V3.85715C17.1429 3.0615 17.4589 2.29844 18.0215 1.73583C18.5841 1.17322 19.3472 0.857147 20.1429 0.857147Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScriptsSidebar);
export default __webpack_public_path__ + "static/media/ScriptsSidebar.e4f8daf167f5c2242fd9439519d32955.svg";
export { ForwardRef as ReactComponent };